import api from "../services/apiService";
import { CACHE_CONFIG } from "../constants/cacheConfig";
import { setCache } from "../store/cacheSlice";
import { hashParamsAndBody } from "./hashParamsAndBody";

const generateCacheKey = (baseKey, axiosConfig) => {
  const hash = hashParamsAndBody({
    params: axiosConfig.params,
    data: axiosConfig.data,
  });
  return `${baseKey}:${hash}`;
};

export const cacheApiRequest = async (
  configKey,
  dispatch,
  cache,
  override = {}
) => {
  const config = CACHE_CONFIG[configKey];
  if (!config) throw new Error(`No CACHE_CONFIG for ${configKey}`);

  const axiosConfig = {
    url: override.url || config.url,
    method: override.method || config.method,
    ...(override.data ? { data: override.data } : {}),
    ...(override.params ? { params: override.params } : {}),
  };

  const key = generateCacheKey(configKey, axiosConfig);
  const now = Date.now();
  const cacheEntry = cache[key];

  if (cacheEntry && now - cacheEntry.timestamp < config.duration * 1000) {
    return cacheEntry.data;
  }

  const response = await api(axiosConfig);
  const data = response.data.data;
  dispatch(setCache({ key, data }));
  return data;
};

export const postrequest = async (
  configKey,
  dispatch,
  cache,
  override = {}
) => {
  const config = CACHE_CONFIG[configKey];
  if (!config) throw new Error(`No CACHE_CONFIG for ${configKey}`);

  const axiosConfig = {
    url: override.url || config.url,
    method: override.method || config.method,
    ...(override.data ? { data: override.data } : {}),
    ...(override.params ? { params: override.params } : {}),
  };

  const key = generateCacheKey(configKey, axiosConfig);
  const now = Date.now();
  const cacheEntry = cache[key];

  if (cacheEntry && now - cacheEntry.timestamp < config.duration * 1000) {
    return cacheEntry.data;
  }

  const response = await api(axiosConfig);
  const data = response.data;
  dispatch(setCache({ key, data }));
  return data;
};
